import { connect } from 'react-redux';
import PersonalInfo from './PersonalInfoFull.tsx';
import { personalInfoActions } from './personalInfoActions';

function mapStateToProps(state) {
    const challengerDegenerate = state.app.appConfig.CHALLENGER_DEGENERATE;
    const visibleFieldsObject = state.app.clientConfig.presentationConfig.visibleFields.profile;
    const showDobAndGenderCaution =
        state.app.presentationConfig.showSections.showDobAndGenderCaution ?? false;
    const currentLanguage = state.app.locale;
    const visibleFieldsConfig = Object.entries(visibleFieldsObject).map(([key, value]) => {
        let currentOrder;
        if (value.order && typeof value.order === 'object') {
            currentOrder = value.order[currentLanguage];
        }

        let currentFormat;
        if (value.format && typeof value.format === 'object') {
            currentFormat = value.format[currentLanguage];
        }

        return {
            fieldName: key,
            required: value.required,
            order: currentOrder ?? 0,
            showCsUrl: value.showCsUrl ?? true,
            format: currentFormat ?? 'dd-mm-yyyy',
        };
    });
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.PERSONAL_INFORMATION
            : '',
        user: state.member,
        personalInfoState: state.personalInfo,
        app: state.app,
        visibleFieldsConfig,
        challengerDegenerate,
        showDobAndGenderCaution,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updatePersonalInfo: (data) => {
            dispatch(personalInfoActions.updateMemberInfo(data));
        },
    };
}

const PersonalInfoContainer = connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);

export default PersonalInfoContainer;
